import { render, staticRenderFns } from "./slide-box.vue?vue&type=template&id=612138d2&scoped=true"
import script from "./slide-box.vue?vue&type=script&lang=js"
export * from "./slide-box.vue?vue&type=script&lang=js"
import style0 from "./slide-box.vue?vue&type=style&index=0&id=612138d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612138d2",
  null
  
)

export default component.exports